import NewCrisisListModal from "./new-crisis-list-modal";

export default NewCrisisListModal;